import React from "react";

export const TabsForDetailedInfoContext = React.createContext({});
